import CryptoJS from "crypto-js";
import { IUserLogin } from "../models/IUserLogin";
import { ITokenData } from "../models/ITokenData";
import { ILoginInfo } from "../models/ILoginInfo";
import { configWithUserToken } from "../services/config";
import { IUserDetail } from "../models/IUserDetail";
import { IMenuExtra } from "../models/IMenuExtra";
import { OrderStatus } from "../models/IOrderStatusList";
import { CustomerAddress } from "../models/IOrders";
import { getTownById } from "../services/locations";
const key = "Mtoken";
export const encrypt = (plainText: string) => {
  const cipherText = CryptoJS.AES.encrypt(plainText, key).toString();
  return cipherText;
};

export const decrypt = (cipherText: string) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, key);

  const plainText = bytes.toString(CryptoJS.enc.Utf8);

  return plainText;
};

export const getWebToken = () => {
  const stToken = localStorage.getItem("MA");
  if (stToken) {
    try {
      const plainText = decrypt(stToken);
      const objToken: ITokenData = JSON.parse(plainText);
      return objToken;
    } catch (error) {
      localStorage.removeItem("MA");
    }
  }
  return null;
};

export const getUserToken = () => {
  const stToken = localStorage.getItem("user");
  if (stToken) {
    try {
      const plainText = decrypt(stToken);
      const objToken: ITokenData = JSON.parse(plainText);
      return objToken;
    } catch (error) {
      localStorage.removeItem("user");
    }
  }
  return null;
};

const ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export const isSuperAdmin = (): boolean => {
  const token = getUserToken();
  if (!token?.token) return false;
  try {
    const payload = JSON.parse(atob(token.token.split(".")[1]));
    const roles = payload[ROLE_CLAIM];
    if (Array.isArray(roles)) return roles.includes("SuperAdmin");
    return roles === "SuperAdmin";
  } catch {
    return false;
  }
};

export const getOrCreateDeviceId = (): string => {
  const stored = localStorage.getItem("deviceId");
  if (stored) return stored;
  const newId = crypto.randomUUID();
  localStorage.setItem("deviceId", newId);
  return newId;
};

export const validUserLogin = (username: string, password: string): boolean => {
  if (username === "" || password === "") {
    return false;
  }
  return true;
};

export function formatDateToDayMonthYear(dateString: string): string {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, '0'); // Gün
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Ay (0'dan başladığı için +1 ekliyoruz)
  const year = date.getUTCFullYear(); // Yıl

  return `${day}/${month}/${year}`;
}

export const DateToString=(date:Date):string=>{
  const day = String(date.getDate()).padStart(2, "0"); // 2 haneli gün
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 2 haneli ay (0 bazlı olduğu için +1)
  const year = date.getFullYear(); // Yıl

  return `${month}-${day}-${year}`; // "gg-mm-yyyy" formatı
}

export const getUserDetails = (): Promise<IUserDetail | null> => {
  const userItem = localStorage.getItem("user");
  if (userItem) {
    try {
      const plainText = decrypt(userItem);
      const objToken: ILoginInfo = JSON.parse(plainText);

      return configWithUserToken
        .get<IUserDetail>("Auth/CustomerDetails/" + objToken.userId)
        .then((res) => {
          if (res.data) {
            console.log("userDetails", res.data);
            return res.data;
          }
          return null; // Explicitly return null if no data
        })
        .catch(() => null); // Catch any errors and return null
    } catch (error) {
      localStorage.removeItem("user");
      return Promise.resolve(null); // Return a resolved promise with null
    }
  }
  return Promise.resolve(null); // Return a resolved promise with null
};

export function getMenuExtrasList(extras: string): any {
  return extras
    ? extras.split(";").map(note => note.trim()).filter(note => note !== "")
    : [];
}


export function parseMenuExtras(extras: string | null | undefined): IMenuExtra[] {
  // Ek seçilmemiş satırlarda alan null/boş gelir; o durumda ek yoktur.
  if (!extras) return [];
  return extras.split(";").map(extra => {
    const nameMatch = extra.match(/^(.*?)\s*x(\d+)/);
    const priceMatch = extra.match(/->\s*(\d+(?:\.\d+)?)/);
    const totalMatch = extra.match(/Toplam Tutar:\s*(\d+(?:\.\d+)?)/);

    if (nameMatch && priceMatch && totalMatch) {
      return {
        name: nameMatch[1].trim(),
        quantity: parseInt(nameMatch[2], 10),
        price: parseFloat(priceMatch[1]),
        total: parseFloat(totalMatch[1]),
      };
    }
    return null;
  }).filter(extra => extra !== null) as IMenuExtra[];
}


export const orderStatuses: { [key: string]: OrderStatus } = {
  "21238beb-3a97-420d-8fad-626166db1b1e": {
    id: "21238beb-3a97-420d-8fad-626166db1b1e",
    orderStatusNameTr: "Siparişinizi Aldık.",
    orderStatusNameEn: "",
    task:0
  },
  "55b08d65-d81a-4712-8332-8e59e8340940": {
    id: "55b08d65-d81a-4712-8332-8e59e8340940",
    orderStatusNameTr: "Teslim edildi.",
    orderStatusNameEn: "Delivered.",
    task:1
  },
  "700924e1-a720-4dbe-8374-6ae56adc4346": {
    id: "700924e1-a720-4dbe-8374-6ae56adc4346",
    orderStatusNameTr: "Hazırlanıyor.",
    orderStatusNameEn: "Getting Ready.",
    task:2
  },
  "840e3442-8a36-4404-8e4b-f6d1fafbbf3b": {
    id: "840e3442-8a36-4404-8e4b-f6d1fafbbf3b",
    orderStatusNameTr: "Yolda",
    orderStatusNameEn: "On the way",
    task:3
  },
  "950565f2-baa3-4977-bef8-8e1dc5962123": {
    id: "950565f2-baa3-4977-bef8-8e1dc5962123",
    orderStatusNameTr: "İptal.",
    orderStatusNameEn: "Cancel.",
    task:4
  }
};

export const getStatusColor = (statusCode:number) => {
  switch (statusCode) {
    case 0:
      return "text-primary"; // Mavi
    case 1:
      return "text-success"; // Yeşil
    case 2:
      return "text-warning"; // Sarı
    case 3:
      return "text-warning"; // Sarı
    case 4:
        return "text-danger"; // Kirmizi
    default:
      return "text-muted"; // Varsayılan (Soluk Gri)
  }
};

export const margeCustomerAdres=(adres:CustomerAddress):string=>{
let adrestText:string='';
if(adres?.townId){
  getTownById(adres.townId).then((response)=>{

    adrestText= adres.customerAddressNote+response.data.townNameTr + "/"+response.data.city.cityNameTr;
    return adrestText;
  });

}

return adrestText;


}
